import store from '..'
import axios from 'axios'
import API from '@/common/api'

export default {
  namespaced: true,
  state: {
    list: [],
    setMenu: {
      main: {},
      list: []
    },
    item: {},
    // tree: [],
    previewState: false,
    templates: []
  },
  mutations: {
    updateList (state, data) {
      state.list = data
    },
    updateItemSns ({ state }, data) {
      state.item.snsList = data
    },
    setPreview (state, data) {
      state.preview = data
    },
    previewState (state, data) {
      state.previewState = data
    }
  },
  actions: {
    updateList (context, data) {
      context.commit('updateList', data)
    },
    updateTree ({ state }, data) {
      state.item.tree = data
    },
    setItem ({ state }, data) {
      state.item = data
    },
    setListData ({ state }, data) {
      /** 소팅할 것 */
      state.list = data
    },
    async getMenuList () {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_ALL_MENU_PARAMS,
          id: store.state.authentication.requestId
        })
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async getMenuListItem ({ state }, id) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_MENU_PARAMS,
          id: store.state.authentication.requestId,
          menuId: id
        })
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async setMenuListItem ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.CREATE_MENU_PARAMS,
          id: store.state.authentication.requestId,
          data: data
        })
        return true
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    async updateMenuListItem ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.UPDATE_MENU_PARAMS,
          id: store.state.authentication.requestId,
          data: data
        })
        return true
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    async delMenuListItem ({ state }, ids) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.DELETE_MENU_PARAMS,
          id: store.state.authentication.requestId,
          menuIds: ids
        })
        return true
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    setMenuListData ({ dispatch }) {
      dispatch('getMenuList').then(res => {
        const data = !res ? [] : res
        dispatch('setListData', data).then(() => {
          return true
        })
      }).catch((ex) => {
        // alert(ex)
        console.log(ex)
        return false
      })
    },
    async getMenuItem ({ state }, id) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: `menu/item/${id}.json`
        })
        return res.data.message
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    async setMenuItem ({ state }, data) {
      try {
        return axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.SET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: `menu/item/${data.id}.json`,
          data: JSON.stringify(data.data)
        })
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    async delMenuItem ({ state }, id) {
      try {
        return axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.DEL_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: `menu/item/${id}.json`
        })
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    async getMenuTemplates ({ state }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_ALL_MENU_PARAMS,
          id: 'a.000'
        })
        state.templates = res.data.message
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async getTemplateItem ({ state }, id) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_GVF_PARAMS,
          id: 'a.000',
          file: `menu/item/${id}.json`
        })
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    }
  },
  getters: {
    list: state => {
      return state.list
    },
    templates: state => state.templates,
    /*
    item: state => id => {
      return state.list[id]
    },
    tree (state) {
      return state.tree
    },
    */
    getItem (state) {
      return state.item
    },
    getTree (state) {
      return state.item.tree
    },
    getPreview (state) {
      return state.preview
    },
    getPreviewState (state) {
      return state.previewState
    }
  }
}
